import Menu from './organization_management.vue';

export default Menu;
